import { Link } from "react-router-dom";
import { ArrowUpRight, Cloud, DatabaseBackup, Headset, Server, ShieldCheck } from "lucide-react";
import { SERVICES } from "../../data/services";
import { Reveal } from "../Reveal";

const ICONS = { Server, ShieldCheck, Cloud, Headset, DatabaseBackup };

export const ServicesGrid = () => (
  <section className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32" id="services" data-testid="services-section">
    <Reveal>
      <p className="eyebrow">What we do</p>
      <h2 className="mt-6 max-w-4xl font-display text-4xl font-black leading-[1.02] tracking-tighter text-white md:text-6xl lg:text-7xl">
        The full IT department, <span className="text-brand">without the payroll.</span>
      </h2>
      <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#C9D2DE] md:text-lg">
        Five disciplines, one accountable team. Every Sempresera client gets all of it — no tiers, no gates, no
        premium upsells.
      </p>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-6">
      {SERVICES.map((s, i) => {
        const Icon = ICONS[s.icon];
        const wide = i < 2 ? "md:col-span-3" : "md:col-span-2";
        return (
          <Reveal key={s.slug} delay={i * 0.08} className={wide}>
            <Link
              to={`/services/${s.slug}`}
              data-testid={`service-card-${s.slug}`}
              className="group glass flex h-full flex-col justify-between p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand/40"
            >
              <div>
                <Icon size={28} className="text-brand" strokeWidth={1.5} />
                <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-white">{s.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#C9D2DE]">{s.short}</p>
              </div>
              <span className="mt-8 inline-flex items-center gap-2 font-display text-xs font-bold uppercase tracking-[0.2em] text-[#A8B4C2] transition-colors duration-300 group-hover:text-brand">
                Explore <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </Link>
          </Reveal>
        );
      })}
    </div>
  </section>
);
